import React from 'react';
import { Link, generatePath } from 'react-router-dom';
import { castArray } from 'lodash';
import { Menu, theme } from 'antd';
import { IterateRoutes, MapRoutes } from '../../router';

const { useToken } = theme;

interface SidebarProps {
  routes: RouteItem[];
  drawerData: UseDrawerReturnType;
  onNavigate?: () => void;
}

function Sidebar({ routes, drawerData, onNavigate }: SidebarProps) {
  const { token } = useToken();
  const getMenuLabel = ({ icon, name }: RouteItem) => (
    <>
      {icon}
      <span>{name}</span>
    </>
  );

  const items = IterateRoutes({
    routes,
    renderParent: ({ route, key, children }) => {
      if (route.invisible) return null;

      const filtered = children.filter(Boolean);
      return (
        <Menu.SubMenu key={key} title={getMenuLabel(route)}>
          {filtered}
        </Menu.SubMenu>
      );
    },
    render: ({ route, key, parent }) => {
      if (route.invisible || parent?.invisible) return null;
      const label = getMenuLabel(route);
      return (
        <Menu.Item
          key={key}
          onClick={() => {
            if ('drawer' in route) drawerData.openDrawer(route.drawer);
            onNavigate?.();
          }}
        >
          {'path' in route ? (
            <Link to={generatePath(castArray(route.path)[0])}>{label}</Link>
          ) : (
            label
          )}
        </Menu.Item>
      );
    },
  });

  return (
    <div className="sidebar-content">
      <Link to="/" className="sider-menu-logo" style={{ color: token.colorPrimaryActive }}>
        <img src="./LOGO_RADIAN.svg" alt="Radian" height={40} />
      </Link>
      <MapRoutes
        routes={routes}
        default={() => (
          <Menu mode="inline" theme="light">
            {items}
          </Menu>
        )}
        render={({ parent, key }) => (
          <Menu
            mode="inline"
            defaultOpenKeys={parent ? [parent.key] : []}
            defaultSelectedKeys={[key]}
            theme="light"
          >
            {items}
          </Menu>
        )}
      />
    </div>
  );
}

export default Sidebar;
